import React from 'react';
import { Helmet } from 'react-helmet';
import DesktopResponsive from './responsive/Home/DesktopResponsive';
import MobileResponsive from './responsive/Home/MobileResponsive';
import { toggleDomainResults } from "../actions/domainActions";
import { connect } from 'react-redux';

function Home(props) {
  const [domainName, setDomainName] = React.useState({ name: '' });
  const [error, setError] = React.useState({ type: '', message: '' });
  const { loggedIn, history, isDomainResultsOpen, toggleDomainResults } = props;

  const detectCurrentDomainName = React.useCallback(() => {
    let currentDomain = window.location.hostname;
    console.log('This is the domain: ', window.location.href);
    var referrer = window.location.href;
    console.log('referrer url', referrer);
    if (currentDomain.includes('blockpire')) {
      props.history.push('/gemstatehearing');
      console.log('Current domain: ', currentDomain);
    }
  }, [props.history]);


  React.useEffect(
    () => {
      detectCurrentDomainName();
      if (loggedIn) {
        history.push('/dashboard');
      }
    },
    [loggedIn, detectCurrentDomainName, history]
  );

  const handleDomainClose = () => {
    toggleDomainResults();
  };

  const handleKeyDown = event => {
    if (event.key === 'Enter') {
      handleDomainOpen();
    }
  };

  // const checkIfValidDomain = domain => {
  // Check to see if it has a .something
  //   if (
  //     domain.includes('.com') ||
  //     domain.includes('.net') ||
  //     domain.includes('.co') ||
  //     domain.includes('.xyz') ||
  //     domain.includes('.me') ||
  //     domain.includes('.io')
  //   ) {
  //     return true;
  //   }
  // };

  const handleDomainOpen = event => {
    if (domainName.name && domainName.name.length < 64) {
      toggleDomainResults();
    } else {
      setError({
        type: 'valid-domain',
        message: 'Please enter a valid domain name',
      });
    }
  };

  const handleOnChange = evt => {
    setDomainName({ name: evt.target.value });
  };



  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>EditPage AI Website Builder | Generate, ReMix, and Publish</title>
        <meta
          content="Describe your site, generate a real homepage, ReMix instantly, click to edit text and images, and launch with Free, Growth, Scale, or Enterprise plans."
          name="description"
        />
        <meta
          property="og:title"
          content="EditPage AI Website Builder | Generate, ReMix, and Publish"
        />
        <meta
          property="og:description"
          content="Describe your site, generate a real homepage, ReMix instantly, click to edit text and images, and launch with Free, Growth, Scale, or Enterprise plans."
        />
        <meta
          name="twitter:title"
          content="EditPage AI Website Builder | Generate, ReMix, and Publish"
        />
        <meta
          name="twitter:description"
          content="Describe your site, generate a real homepage, ReMix instantly, click to edit text and images, and launch with Free, Growth, Scale, or Enterprise plans."
        />
        <meta content="EditPage" name="generator" />
      </Helmet>
      <DesktopResponsive
        open={isDomainResultsOpen}
        domainName={domainName}
        error={error}
        handleKeyDown={handleKeyDown}
        handleDomainClose={handleDomainClose}
        handleDomainOpen={handleDomainOpen}
        handleOnChange={handleOnChange}
      />
      <MobileResponsive
        open={isDomainResultsOpen}
        domainName={domainName}
        error={error}
        handleKeyDown={handleKeyDown}
        handleDomainClose={handleDomainClose}
        handleDomainOpen={handleDomainOpen}
        handleOnChange={handleOnChange}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    isDomainResultsOpen: state.domain.isDomainResultsOpen
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    toggleDomainResults: () => {
      dispatch(toggleDomainResults())
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);